export default __webpack_public_path__ + "static/media/testimonials-bg.70fd0efd.webp";